import { UserRegistrationForm } from '../components/UserRegistrationForm';
import { UserRegistrationComplete } from '../components/UserRegistrationComplete';

export * from '../components/Index';
export * from '../components/PatientInformationForm';
export * from '../components/SymptomForm';
export * from '../components/ExaminationMenuForm';
export * from '../components/ReservationDateTimeForm';

export const registrationRoutes = [
  // { path: '/patient/registration', element: <UserRegistrationForm /> },
  // { path: '/patient/registration/complete', element: <UserRegistrationComplete /> }
];
